module.exports = __webpack_public_path__ + "static/media/insta-icon.bce03928.png";